// extracted by mini-css-extract-plugin
export default {"loadMoreWrapper":"archive-module__loadMoreWrapper__Cpr3h"};